export class Team {
  public TeamId = '';
  public TeamImage = '';
  public TeamName = '';

  constructor() { }

  public static parse(data: any): Team {
    const team = new Team();

    if (data) {
      if (data.TeamId || data.EquipoId) {
        team.TeamId = data.TeamId || data.EquipoId;
      }
      if (data.TeamImage || data.EquipoImagen) {
        team.TeamImage = data.EquipoImagen || data.EquipoImagen;
      } else {
        delete team.TeamImage;
      }
      if (data.TeamName || data.EquipoNombre) {
        team.TeamName = data.TeamName || data.EquipoNombre;
      }
    }

    return team;
  }
}
